export function decodeBase64ToNumber(base64: string) {
    return Number(window.atob(base64.toString()))
}
